// What a creator site's sign-up form shows (see email-subscribers.ts), with no schema library.

/** The consent a visitor gives, saved word for word with their address. */
export const mailingListConsent = (name: string) =>
  `I agree to receive email updates from ${name}.`;
